import {PrimeIcons} from "primereact/api";
import {Tooltip} from "primereact/tooltip";
import {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";

/**
 * Einheitliche Breite der Aktions-Icon-Spalte aller Eingabetabellen (Bestandsverzeichnis,
 * Abteilung II, BGF, Besondere Objektmerkmale, Baukostenanpassung, SWOT, Auflagen).
 * Als gemeinsame Konstante, damit die Spalte überall exakt gleich breit bleibt; die Summenzeile
 * der Baukostenanpassung richtet ihren Platzhalter an demselben Wert aus.
 */
export const ROW_ACTION_COLUMN_STYLE = {width: "2rem"};

/**
 * Klickbares Minus-Icon zum Löschen einer Tabellenzeile, samt Tooltip.
 * Einzige Stelle, an der dieses Icon gebaut wird – Aussehen, Tooltip und Verhalten bleiben so
 * über alle Eingabetabellen hinweg gleich.
 * @param {{onDelete: () => void, disabled?: boolean}} props
 * @return {React.ReactNode}
 */
export function RowDeleteIcon({onDelete, disabled = false}) {
    const ref = useRef(null);
    const [mounted, setMounted] = useState(false);
    const {t} = useTranslation();

    useEffect(() => {
        if (ref.current && !mounted) {
            setMounted(true); // Re-Render anstoßen, sobald die Ref steht – sonst bleibt das Tooltip-Target null
        }
    }, [mounted]);

    return (
        <>
            <Tooltip target={ref.current} className="custom-tooltip tooltip-nowrap" disabled={disabled} />
            <span
                ref={ref}
                className={`${PrimeIcons.MINUS_CIRCLE} cursor-pointer`}
                data-pr-tooltip={t("general.deleteRowTooltip")}
                data-pr-position="top"
                onClick={() => !disabled && onDelete()}
            />
        </>
    );
}
